export const MILITARY_BRANCHES = {
  army: "United States Army",
  navy: "United States Navy",
  "air-force": "United States Air Force",
  marines: "United States Marine Corps",
  "coast-guard": "United States Coast Guard",
  "space-force": "United States Space Force",
};

export const formatMilitaryBranch = (branchCode) => {
  return MILITARY_BRANCHES[branchCode] || branchCode;
};
